import Card from '@trinsly/common/src/components/atoms/card'
import Column from '@trinsly/common/src/components/atoms/column'
import Heading from '@trinsly/common/src/components/atoms/heading'
import Separator from '@trinsly/common/src/components/atoms/separator'
import Text from '@trinsly/common/src/components/atoms/text'
import Button from '@trinsly/common/src/components/molecules/button'
import Modal from '@trinsly/common/src/components/molecules/modal'

export type Deactivate2FaConfirmationModalProps = {
  visible: boolean
  onRequestClose: () => void
  onConfirm: () => void
  pending: boolean
}

export const Deactivate2FaConfirmationModal = ({
  visible,
  onRequestClose,
  onConfirm,
  pending,
}: Deactivate2FaConfirmationModalProps) => {
  return (
    <>
      <Modal size="sm" visible={visible} onRequestClose={onRequestClose}>
        <Card className="overflow-hidden">
          <Column className="p-md">
            <Heading size="xl" fontWeight="bold">
              Deactivate Two-Factor Authentication
            </Heading>
            <Separator size="sm" />
            <Text>Are you sure you want to disable 2FA for this account?</Text>
          </Column>
          <Modal.Footer>
            <Button className="min-w-28" onClick={onRequestClose}>
              Close
            </Button>
            <Separator size="sm" />
            <Button
              className="min-w-48"
              intent="danger"
              pending={pending}
              onClick={onConfirm}
            >
              Deactivate 2FA
            </Button>
          </Modal.Footer>
        </Card>
      </Modal>
    </>
  )
}

export default Deactivate2FaConfirmationModal
